import { createQueryKeys } from '@lukemorales/query-key-factory';

import { get } from '@/api/api';
import type {
  FanguardApiContractsClientVenueDetailModel,
  FanguardApiContractsClientVenueSummaryModel,
} from 'src/api/generated';
import type { VenueLookup } from 'src/types/VenuesTypes';

export const VENUES_URI = 'venues';
export const VENUES_LOOKUP_URI = `${VENUES_URI}/lookup`;

export const sortVenuesByName = <T extends { name?: string | null }>(venues: T[]): T[] =>
  [...venues].sort((a, b) => (a.name ?? '').localeCompare(b.name ?? ''));

export const venuesQueries = createQueryKeys(VENUES_URI, {
  all: null,
  list: {
    queryKey: ['list'] as const,
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientVenueSummaryModel[]>({ uri: VENUES_URI });
      return sortVenuesByName(response.data ?? []);
    },
  },
  lookup: {
    queryKey: ['lookup'] as const,
    queryFn: async () => {
      const response = await get<VenueLookup[]>({ uri: VENUES_LOOKUP_URI });
      return sortVenuesByName(response.data ?? []);
    },
  },
  detail: (id: string) => ({
    queryKey: [id],
    queryFn: async () => {
      const response = await get<FanguardApiContractsClientVenueDetailModel>({ uri: `${VENUES_URI}/${id}` });
      return response.data;
    },
  }),
});
